import { marketingHomeUrl } from '../i18n';
import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from 'react';
import { sendLoginLink, loginWithPassword } from '../utils/loginUtils';
import { buildApiUrl } from '../utils/apiClient';
import '../css/LegacyLogin.css';

function LegacyLogin() {
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showTooltip, setShowTooltip] = useState(false);
  const [installPrompt, setInstallPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(false);
  const [usePasswordAuth, setUsePasswordAuth] = useState(false);
  const inviteToken = new URLSearchParams(window.location.search).get('invite_token') || '';

  useEffect(() => {
    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      // Stash the event so it can be triggered later
      setInstallPrompt(e);
      setShowInstallButton(true);
    });
  }, []);

  const handleInstall = async () => {
    if (!installPrompt) return;

    // Show the prompt
    installPrompt.prompt();

    // Wait for the user to respond to the prompt
    const { outcome } = await installPrompt.userChoice;
    if (outcome === 'accepted') {
      setShowInstallButton(false);
    }
    // Clear the saved prompt since it can't be used again
    setInstallPrompt(null);
  };

  const handleSendLink = async () => {
    try {
      await sendLoginLink(email, inviteToken);
      alert(t('auth.linkSent'));
    } catch (error) {
      alert(t('auth.loginError'));
    }
  };

  const handlePasswordLogin = async () => {
    if (!email || !password) {
      alert(t('auth.requiredCredentials'));
      return;
    }

    try {
      await loginWithPassword(email, password);
      if (inviteToken) {
        window.location.href = buildApiUrl(`/join?token=${encodeURIComponent(inviteToken)}`);
        return;
      }
      window.location.reload();
    } catch (error) {
      alert(t('auth.loginError'));
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="image-section">
          <img src="/flipped_doctor_image.webp" alt="NoteSmart" />
        </div>

        <div className="form-section">
          <h1>{t('auth.welcome')}</h1>
          <p>{t('auth.subtitle')}</p>

          {showInstallButton && (
            <button
              className="install-button"
              onClick={handleInstall}
            >{t('auth.install')}</button>
          )}

          <div className="input-container">
            <label>{t('common.emailLabel')}<input
                type="email"
                placeholder="email@provider.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onFocus={() => setShowTooltip(true)}
                onBlur={() => setShowTooltip(false)}
              />
            </label>
            {showTooltip && !usePasswordAuth && (
              <div className="tooltip">{t('auth.magicHelp')}</div>
            )}
          </div>

          {usePasswordAuth && (
            <div className="input-container">
              <label>{t('auth.passwordLabel')}<input
                  type="password"
                  placeholder={t('auth.passwordPlaceholder')}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </label>
            </div>
          )}

          <div className="auth-toggle">
            <span
              className="toggle-text"
              onClick={() => setUsePasswordAuth(!usePasswordAuth)}
            >
              {usePasswordAuth ? t('auth.useMagic') : t('auth.usePassword')}
            </span>
          </div>

          <button onClick={usePasswordAuth ? handlePasswordLogin : handleSendLink}>
            {usePasswordAuth ? t('auth.signIn') : t('auth.sendLink')}
          </button>
          <button className="home-button" onClick={() => window.location.href = marketingHomeUrl(i18n.language)}>{t('common.home')}</button>
        </div>
      </div>
    </div>
  );
}

export default LegacyLogin;
